<template>
  <div class="mains">
    <div class="campus">校区管理</div>
    <div class="jibenxinxi">
      <el-card>
        <div class="jiben">校区管理</div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, index) in data.slice(
              (searchForm.page - 1) * searchForm.per_page,
              searchForm.page * searchForm.per_page
            )" :key="index">
            <div class="grid-content bg-purple">
              <div class="logo_name">
                <img :src="logourl ? logourl : src.iconss" style="height: 2.5vw" />
                <span>{{ item.name }}</span>
                <span class="shiyong">
                  <i class="icon_dui">
                    <img :src="item.booleanStatus ? src.icon : src.icons" alt />
                  </i>
                  <span :class="item.booleanStatus ? 'xian' : 'yin'">正在使用</span>
                  <span :class="item.booleanStatus ? 'yin' : 'xian1'">停止使用</span>
                </span>
              </div>
              <div class="logo_guanli">校区管理员 ：{{ item.orgadmin }}</div>
              <div class="ziliao">
                <div class="yuan">
                  <span>
                    <div>员工数</div>
                    <div class="shuzi">{{ item.curEmpNum }}</div>
                  </span>
                  <span class="xin">
                    <div class="zeng">新增员工</div>
                    <div class="shuzi1">
                      <span :class="empNumRateIncs ? 'shuzi1_g' : 'shuzi1_r'">{{
                        item.incEmpNum
                      }}</span>
                      <i class="shuzi1_img">
                        <img :src="empNumRateIncs ? src.zeng : src.jian" alt />
                      </i>
                    </div>
                  </span>
                </div>
                <div class="yuan">
                  <span>
                    <div>学员数</div>
                    <div class="shuzi">{{ item.curStudentNum }}</div>
                  </span>
                  <span class="xin">
                    <div class="zeng">新增学员</div>
                    <div class="shuzi1">
                      <span :class="studentNumRateIncs ? 'shuzi1_g' : 'shuzi1_r'">{{ item.incStudentNum }}</span>
                      <i class="shuzi1_img">
                        <img :src="studentNumRateIncs ? src.zeng : src.jian" alt />
                      </i>
                    </div>
                  </span>
                </div>
                <div class="yuan">
                  <span>
                    <div>班级数</div>
                    <div class="shuzi">{{ item.curClassNum }}</div>
                  </span>
                  <span class="xin">
                    <div class="zeng">新增班级</div>
                    <div class="shuzi1">
                      <span :class="classNumRateIncs ? 'shuzi1_g' : 'shuzi1_r'">{{ item.incClassNum }}</span>
                      <i class="shuzi1_img">
                        <img :src="classNumRateIncs ? src.zeng : src.jian" alt />
                      </i>
                    </div>
                  </span>
                </div>
              </div>
              <div class="jinru">
                <div>创建时间：{{ item.showCreateTime }}</div>
                <div class="jinru_xiaoqu">
                  <el-button type="primary" @click="jinruxiaoqu(item)">
                    进入校区
                  </el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchForm.page"
          :page-size="searchForm.per_page" layout="prev, pager, next, jumper" :total="total"></el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'campusmanagement',
  data() {
    return {
      data: [],
      src: {
        icon: '',
        icons: '',
        iconss: '',
        zeng: '',
        jian: '',
      },
      logourl: false,
      classNumRateIncs: '1',
      empNumRateIncs: '1',
      studentNumRateIncs: '1',
      // 检索表单数据对象
      searchForm: {
        page: 1, // 当前数据记录页码
        per_page: 4, // 分页数据记录条数(10~50)
        begin_pubdate: '', // 开始时间
        end_pubdate: '', // 结束时间
        channel_id: '', // 频道id
        status: '', // 文章状态，''-全部, 0-草稿，1-待审核，2-审核通过，3-审核失败
      },
      total: 0,
    };
  },
  mounted() {
    this.src.icon = require('@/assets/img/campus-manage/dui.png');
    this.src.icons = require('@/assets/img/campus-manage/cha.png');
    this.src.iconss = require('@/assets/img/campus-manage/logo.png');
    this.src.zeng = require('@/assets/img/campus-manage/zengjia.png');
    this.src.jian = require('@/assets/img/campus-manage/jianshao.png');
  },
  watch: {},
  created() {
    // this.getArticleList();
  },
  methods: {
    handleSizeChange(val) {
      // console.log(val)
      this.searchForm.per_page = val;
    },
    handleCurrentChange(val) {
      // console.log(val)
      this.searchForm.page = val;
    },
    shuju() {
      if (this.data === undefined || this.data === null) {
        this.total = 0;
      } else {
        this.total = this.data.length;
      }
    },
    jinruxiaoqu(item) {
      // console.log(item)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/stat/home/queryHomeData',
        method: 'POST',
        data: {
          orgid: item.id,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          // this.$store.commit('orgid', id)
          window.sessionStorage.setItem('orgid', item.id);
          window.sessionStorage.setItem('logUrl', item.logourl);
          window.sessionStorage.setItem('xcxusername', item.name);
          // console.log(id)
          this.$router.push({
            name: 'home',
          });
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('进入校区失败：' + err);
        });
    },
    getArticleList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/stat/home/queryHomeOrgList',
        method: 'POST',
        data: {
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.data = result.data.data;
          if (this.data !== undefined && this.data !== null) {
            for (let i = 0; i < this.data.length; i++) {
              // console.log(this.data[i].studentNumRateInc)
              if (this.data[i].classNumRateInc === '0') {
                this.classNumRateIncs = false;
              } else {
                this.classNumRateIncs = true;
              }
              if (this.data[i].empNumRateInc === '0') {
                this.empNumRateIncs = false;
              } else {
                this.empNumRateIncs = true;
              }
              if (this.data[i].studentNumRateInc === '0') {
                this.studentNumRateIncs = false;
              } else {
                this.studentNumRateIncs = true;
              }
            }
          }
          this.shuju();
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('获得校区失败：' + err);
        });
    },
  },
};
</script>

<style lang="less">
.mains {
  .shouye {
    width: 4vw;
  }

  .jibenxinxi {
    .el-card {
      padding: 64px 0 80px 1.9vw;
      position: relative;

      .jiben {
        font-size: 0.83vw;
        border-left: 3px solid #0090c9ff;
        line-height: 0.83vw;
        padding-left: 0.63vw;
        font-weight: bold;
        position: absolute;
        top: 1.25vw;
        // left: 1.25vw;
        text-align: left;
      }

      .el-row {
        &:last-child {
          margin-bottom: 0;
        }

        .grid-content {
          border-radius: 0.4vw;
          height: 18.1vw;
          background: #fff;
          font-size: 0.73vw;
          color: #333;
          font-weight: 500;
          text-align: left;
          box-shadow: 0px 0px 0.5vw rgba(102, 102, 102, 0.16);
          margin-right: 1.9vw;
          padding: 0.9vw 1vw;

          .logo_name {
            float: left;
            width: 100%;
            position: relative;

            .shiyong {
              position: absolute;
              top: 1vw;
              left: 12.85vw;

              img {
                width: 0.73vw;
                height: 0.73vw;
              }

              span {
                position: absolute;
                top: 0px;
                left: 1.25vw;
                width: 3vw;
                font-size: 0.6vw;
                color: #009e1a;
              }

              .xian {
                color: #009e1a;
              }

              .xian1 {
                color: #e00909;
              }

              .yin {
                display: none;
              }
            }

            span {
              position: absolute;
              top: 0.8vw;
              left: 2.6vw;

              img {
                width: 1.55vw;
                height: 1.55vw;
              }
            }
          }

          .logo_guanli {
            margin: 3.4vw 0 0 0.5vw;
            font-size: 0.68vw;
            color: #333;
          }

          .ziliao {
            margin: 1vw 1.55vw 0 3vw;

            .yuan {
              margin-top: 0.9vw;

              .shuzi {
                font-size: 0.9vw;
                font-weight: bold;
                margin: 0.3vw 0 0 0.45vw;
              }

              .shuzi1 {
                font-size: 0.9vw;
                font-weight: bold;
                margin: 0.3vw 0 0 1vw;

                .shuzi1_img {
                  position: absolute;
                  top: -0.4vw;
                  right: -1.15vw;
                }

                .shuzi1_g {
                  color: #009e1a;
                }

                .shuzi1_r {
                  color: #e00909;
                }
              }

              .xin {
                float: right;
                margin: -1.65vw 1.25vw 0 0;
                width: 3vw;
                border-left: 1px solid #666;
                height: 0.83vw;
                padding-left: 2.45vw;
                position: relative;

                .zeng {
                  position: absolute;
                  top: -0.88vw;
                }
              }
            }
          }

          .jinru {
            margin-top: 1.4vw;
            font-size: 0.63vw;
            font-weight: 400;
            color: #ccc;

            .jinru_xiaoqu {
              float: right;
              margin-top: -1.25vw;

              .el-button--primary {
                width: 5.2vw;
                height: 1.55vw;
                font-weight: bold;
                background: rgba(0, 148, 206, 1);
                box-shadow: 2px 2px 0.3vw rgba(0, 148, 206, 0.2);
                border-radius: 0.8vw;
                line-height: 0.25vw;
                font-size: 0.73vw;
                padding: 0.6vw 1vw;
              }
            }
          }
        }
      }

      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 0.25vw;
        background-color: #fff;
        border: 1px solid #ccc;
        color: #606266;
        min-width: 1.55vw;
        border-radius: 3px;
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #409eff;
        color: #fff !important;
        border: none !important;
      }

      .el-pager {
        li:hover {
          color: #00a6e6 !important;
          border: 1px solid #00a6e6 !important;
        }
      }

      .el-pagination__editor.el-input {
        width: 25px;
      }

      .el-pagination {
        position: absolute;
        bottom: 4%;
        right: 2.2%;
      }
    }
  }
}
</style>
